/**
 * DPLocksmith - Encrypted and decrypted dp data
 * @version NPM: v1.0.79
 * @version Bower: v1.0.58
 * @link https://gitlab.tw.trendnet.org/isken_huang/dplocksmith
 * @license MIT
 */
/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(u,p){var d={},l=d.lib={},s=function(){},t=l.Base={extend:function(a){s.prototype=this;var c=new s;a&&c.mixIn(a);c.hasOwnProperty("init")||(c.init=function(){c.$super.init.apply(this,arguments)});c.init.prototype=c;c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.init.prototype.extend(this)}},
r=l.WordArray=t.extend({init:function(a,c){a=this.words=a||[];this.sigBytes=c!=p?c:4*a.length},toString:function(a){return(a||v).stringify(this)},concat:function(a){var c=this.words,e=a.words,j=this.sigBytes;a=a.sigBytes;this.clamp();if(j%4)for(var k=0;k<a;k++)c[j+k>>>2]|=(e[k>>>2]>>>24-8*(k%4)&255)<<24-8*((j+k)%4);else if(65535<e.length)for(k=0;k<a;k+=4)c[j+k>>>2]=e[k>>>2];else c.push.apply(c,e);this.sigBytes+=a;return this},clamp:function(){var a=this.words,c=this.sigBytes;a[c>>>2]&=4294967295<<
32-8*(c%4);a.length=u.ceil(c/4)},clone:function(){var a=t.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var c=[],e=0;e<a;e+=4)c.push(4294967296*u.random()|0);return new r.init(c,a)}}),w=d.enc={},v=w.Hex={stringify:function(a){var c=a.words;a=a.sigBytes;for(var e=[],j=0;j<a;j++){var k=c[j>>>2]>>>24-8*(j%4)&255;e.push((k>>>4).toString(16));e.push((k&15).toString(16))}return e.join("")},parse:function(a){for(var c=a.length,e=[],j=0;j<c;j+=2)e[j>>>3]|=parseInt(a.substr(j,
2),16)<<24-4*(j%8);return new r.init(e,c/2)}},b=w.Latin1={stringify:function(a){var c=a.words;a=a.sigBytes;for(var e=[],j=0;j<a;j++)e.push(String.fromCharCode(c[j>>>2]>>>24-8*(j%4)&255));return e.join("")},parse:function(a){for(var c=a.length,e=[],j=0;j<c;j++)e[j>>>2]|=(a.charCodeAt(j)&255)<<24-8*(j%4);return new r.init(e,c)}},x=w.Utf8={stringify:function(a){try{return decodeURIComponent(escape(b.stringify(a)))}catch(c){throw Error("Malformed UTF-8 data");}},parse:function(a){return b.parse(unescape(encodeURIComponent(a)))}},
q=l.BufferedBlockAlgorithm=t.extend({reset:function(){this._data=new r.init;this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=x.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var c=this._data,e=c.words,j=c.sigBytes,k=this.blockSize,b=j/(4*k),b=a?u.ceil(b):u.max((b|0)-this._minBufferSize,0);a=b*k;j=u.min(4*a,j);if(a){for(var q=0;q<a;q+=k)this._doProcessBlock(e,q);q=e.splice(0,a);c.sigBytes-=j}return new r.init(q,j)},clone:function(){var a=t.clone.call(this);
a._data=this._data.clone();return a},_minBufferSize:0});l.Hasher=q.extend({cfg:t.extend(),init:function(a){this.cfg=this.cfg.extend(a);this.reset()},reset:function(){q.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);return this._doFinalize()},blockSize:16,_createHelper:function(a){return function(b,e){return(new a.init(e)).finalize(b)}},_createHmacHelper:function(a){return function(b,e){return(new n.HMAC.init(a,
e)).finalize(b)}}});var n=d.algo={};return d}(Math);
(function(){var u=CryptoJS,p=u.lib.WordArray;u.enc.Base64={stringify:function(d){var l=d.words,p=d.sigBytes,t=this._map;d.clamp();d=[];for(var r=0;r<p;r+=3)for(var w=(l[r>>>2]>>>24-8*(r%4)&255)<<16|(l[r+1>>>2]>>>24-8*((r+1)%4)&255)<<8|l[r+2>>>2]>>>24-8*((r+2)%4)&255,v=0;4>v&&r+0.75*v<p;v++)d.push(t.charAt(w>>>6*(3-v)&63));if(l=t.charAt(64))for(;d.length%4;)d.push(l);return d.join("")},parse:function(d){var l=d.length,s=this._map,t=s.charAt(64);t&&(t=d.indexOf(t),-1!=t&&(l=t));for(var t=[],r=0,w=0;w<
l;w++)if(w%4){var v=s.indexOf(d.charAt(w-1))<<2*(w%4),b=s.indexOf(d.charAt(w))>>>6-2*(w%4);t[r>>>2]|=(v|b)<<24-8*(r%4);r++}return p.create(t,r)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
(function(u){function p(b,n,a,c,e,j,k){b=b+(n&a|~n&c)+e+k;return(b<<j|b>>>32-j)+n}function d(b,n,a,c,e,j,k){b=b+(n&c|a&~c)+e+k;return(b<<j|b>>>32-j)+n}function l(b,n,a,c,e,j,k){b=b+(n^a^c)+e+k;return(b<<j|b>>>32-j)+n}function s(b,n,a,c,e,j,k){b=b+(a^(n|~c))+e+k;return(b<<j|b>>>32-j)+n}for(var t=CryptoJS,r=t.lib,w=r.WordArray,v=r.Hasher,r=t.algo,b=[],x=0;64>x;x++)b[x]=4294967296*u.abs(u.sin(x+1))|0;r=r.MD5=v.extend({_doReset:function(){this._hash=new w.init([1732584193,4023233417,2562383102,271733878])},
_doProcessBlock:function(q,n){for(var a=0;16>a;a++){var c=n+a,e=q[c];q[c]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360}var a=this._hash.words,c=q[n+0],e=q[n+1],j=q[n+2],k=q[n+3],z=q[n+4],r=q[n+5],t=q[n+6],w=q[n+7],v=q[n+8],A=q[n+9],B=q[n+10],C=q[n+11],u=q[n+12],D=q[n+13],E=q[n+14],x=q[n+15],f=a[0],m=a[1],g=a[2],h=a[3],f=p(f,m,g,h,c,7,b[0]),h=p(h,f,m,g,e,12,b[1]),g=p(g,h,f,m,j,17,b[2]),m=p(m,g,h,f,k,22,b[3]),f=p(f,m,g,h,z,7,b[4]),h=p(h,f,m,g,r,12,b[5]),g=p(g,h,f,m,t,17,b[6]),m=p(m,g,h,f,w,22,b[7]),
f=p(f,m,g,h,v,7,b[8]),h=p(h,f,m,g,A,12,b[9]),g=p(g,h,f,m,B,17,b[10]),m=p(m,g,h,f,C,22,b[11]),f=p(f,m,g,h,u,7,b[12]),h=p(h,f,m,g,D,12,b[13]),g=p(g,h,f,m,E,17,b[14]),m=p(m,g,h,f,x,22,b[15]),f=d(f,m,g,h,e,5,b[16]),h=d(h,f,m,g,t,9,b[17]),g=d(g,h,f,m,C,14,b[18]),m=d(m,g,h,f,c,20,b[19]),f=d(f,m,g,h,r,5,b[20]),h=d(h,f,m,g,B,9,b[21]),g=d(g,h,f,m,x,14,b[22]),m=d(m,g,h,f,z,20,b[23]),f=d(f,m,g,h,A,5,b[24]),h=d(h,f,m,g,E,9,b[25]),g=d(g,h,f,m,k,14,b[26]),m=d(m,g,h,f,v,20,b[27]),f=d(f,m,g,h,D,5,b[28]),h=d(h,f,
m,g,j,9,b[29]),g=d(g,h,f,m,w,14,b[30]),m=d(m,g,h,f,u,20,b[31]),f=l(f,m,g,h,r,4,b[32]),h=l(h,f,m,g,v,11,b[33]),g=l(g,h,f,m,C,16,b[34]),m=l(m,g,h,f,E,23,b[35]),f=l(f,m,g,h,e,4,b[36]),h=l(h,f,m,g,z,11,b[37]),g=l(g,h,f,m,w,16,b[38]),m=l(m,g,h,f,B,23,b[39]),f=l(f,m,g,h,D,4,b[40]),h=l(h,f,m,g,c,11,b[41]),g=l(g,h,f,m,k,16,b[42]),m=l(m,g,h,f,t,23,b[43]),f=l(f,m,g,h,A,4,b[44]),h=l(h,f,m,g,u,11,b[45]),g=l(g,h,f,m,x,16,b[46]),m=l(m,g,h,f,j,23,b[47]),f=s(f,m,g,h,c,6,b[48]),h=s(h,f,m,g,w,10,b[49]),g=s(g,h,f,m,
E,15,b[50]),m=s(m,g,h,f,r,21,b[51]),f=s(f,m,g,h,u,6,b[52]),h=s(h,f,m,g,k,10,b[53]),g=s(g,h,f,m,B,15,b[54]),m=s(m,g,h,f,e,21,b[55]),f=s(f,m,g,h,v,6,b[56]),h=s(h,f,m,g,x,10,b[57]),g=s(g,h,f,m,t,15,b[58]),m=s(m,g,h,f,D,21,b[59]),f=s(f,m,g,h,z,6,b[60]),h=s(h,f,m,g,C,10,b[61]),g=s(g,h,f,m,j,15,b[62]),m=s(m,g,h,f,A,21,b[63]);a[0]=a[0]+f|0;a[1]=a[1]+m|0;a[2]=a[2]+g|0;a[3]=a[3]+h|0},_doFinalize:function(){var b=this._data,n=b.words,a=8*this._nDataBytes,c=8*b.sigBytes;n[c>>>5]|=128<<24-c%32;var e=u.floor(a/
4294967296);n[(c+64>>>9<<4)+15]=(e<<8|e>>>24)&16711935|(e<<24|e>>>8)&4278255360;n[(c+64>>>9<<4)+14]=(a<<8|a>>>24)&16711935|(a<<24|a>>>8)&4278255360;b.sigBytes=4*(n.length+1);this._process();b=this._hash;n=b.words;for(a=0;4>a;a++)c=n[a],n[a]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360;return b},clone:function(){var b=v.clone.call(this);b._hash=this._hash.clone();return b}});t.MD5=v._createHelper(r);t.HmacMD5=v._createHmacHelper(r)})(Math);
(function(){var u=CryptoJS,p=u.lib,d=p.Base,l=p.WordArray,p=u.algo,s=p.EvpKDF=d.extend({cfg:d.extend({keySize:4,hasher:p.MD5,iterations:1}),init:function(d){this.cfg=this.cfg.extend(d)},compute:function(d,r){for(var p=this.cfg,s=p.hasher.create(),b=l.create(),u=b.words,q=p.keySize,p=p.iterations;u.length<q;){n&&s.update(n);var n=s.update(d).finalize(r);s.reset();for(var a=1;a<p;a++)n=s.finalize(n),s.reset();b.concat(n)}b.sigBytes=4*q;return b}});u.EvpKDF=function(d,l,p){return s.create(p).compute(d,
l)}})();
CryptoJS.lib.Cipher||function(u){var p=CryptoJS,d=p.lib,l=d.Base,s=d.WordArray,t=d.BufferedBlockAlgorithm,r=p.enc.Base64,w=p.algo.EvpKDF,v=d.Cipher=t.extend({cfg:l.extend(),createEncryptor:function(e,a){return this.create(this._ENC_XFORM_MODE,e,a)},createDecryptor:function(e,a){return this.create(this._DEC_XFORM_MODE,e,a)},init:function(e,a,b){this.cfg=this.cfg.extend(b);this._xformMode=e;this._key=a;this.reset()},reset:function(){t.reset.call(this);this._doReset()},process:function(e){this._append(e);return this._process()},
finalize:function(e){e&&this._append(e);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(e){return{encrypt:function(b,k,d){return("string"==typeof k?c:a).encrypt(e,b,k,d)},decrypt:function(b,k,d){return("string"==typeof k?c:a).decrypt(e,b,k,d)}}}});d.StreamCipher=v.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var b=p.mode={},x=function(e,a,b){var c=this._iv;c?this._iv=u:c=this._prevBlock;for(var d=0;d<b;d++)e[a+d]^=
c[d]},q=(d.BlockCipherMode=l.extend({createEncryptor:function(e,a){return this.Encryptor.create(e,a)},createDecryptor:function(e,a){return this.Decryptor.create(e,a)},init:function(e,a){this._cipher=e;this._iv=a}})).extend();q.Encryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize;x.call(this,e,a,c);b.encryptBlock(e,a);this._prevBlock=e.slice(a,a+c)}});q.Decryptor=q.extend({processBlock:function(e,a){var b=this._cipher,c=b.blockSize,d=e.slice(a,a+c);b.decryptBlock(e,a);x.call(this,
e,a,c);this._prevBlock=d}});b=b.CBC=q;q=(p.pad={}).Pkcs7={pad:function(a,b){for(var c=4*b,c=c-a.sigBytes%c,d=c<<24|c<<16|c<<8|c,l=[],n=0;n<c;n+=4)l.push(d);c=s.create(l,c);a.concat(c)},unpad:function(a){a.sigBytes-=a.words[a.sigBytes-1>>>2]&255}};d.BlockCipher=v.extend({cfg:v.cfg.extend({mode:b,padding:q}),reset:function(){v.reset.call(this);var a=this.cfg,b=a.iv,a=a.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=a.createEncryptor;else c=a.createDecryptor,this._minBufferSize=1;this._mode=c.call(a,
this,b&&b.words)},_doProcessBlock:function(a,b){this._mode.processBlock(a,b)},_doFinalize:function(){var a=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){a.pad(this._data,this.blockSize);var b=this._process(!0)}else b=this._process(!0),a.unpad(b);return b},blockSize:4});var n=d.CipherParams=l.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),b=(p.format={}).OpenSSL={stringify:function(a){var b=a.ciphertext;a=a.salt;return(a?s.create([1398893684,
1701076831]).concat(a).concat(b):b).toString(r)},parse:function(a){a=r.parse(a);var b=a.words;if(1398893684==b[0]&&1701076831==b[1]){var c=s.create(b.slice(2,4));b.splice(0,4);a.sigBytes-=16}return n.create({ciphertext:a,salt:c})}},a=d.SerializableCipher=l.extend({cfg:l.extend({format:b}),encrypt:function(a,b,c,d){d=this.cfg.extend(d);var l=a.createEncryptor(c,d);b=l.finalize(b);l=l.cfg;return n.create({ciphertext:b,key:c,iv:l.iv,algorithm:a,mode:l.mode,padding:l.padding,blockSize:a.blockSize,formatter:d.format})},
decrypt:function(a,b,c,d){d=this.cfg.extend(d);b=this._parse(b,d.format);return a.createDecryptor(c,d).finalize(b.ciphertext)},_parse:function(a,b){return"string"==typeof a?b.parse(a,this):a}}),p=(p.kdf={}).OpenSSL={execute:function(a,b,c,d){d||(d=s.random(8));a=w.create({keySize:b+c}).compute(a,d);c=s.create(a.words.slice(b),4*c);a.sigBytes=4*b;return n.create({key:a,iv:c,salt:d})}},c=d.PasswordBasedCipher=a.extend({cfg:a.cfg.extend({kdf:p}),encrypt:function(b,c,d,l){l=this.cfg.extend(l);d=l.kdf.execute(d,
b.keySize,b.ivSize);l.iv=d.iv;b=a.encrypt.call(this,b,c,d.key,l);b.mixIn(d);return b},decrypt:function(b,c,d,l){l=this.cfg.extend(l);c=this._parse(c,l.format);d=l.kdf.execute(d,b.keySize,b.ivSize,c.salt);l.iv=d.iv;return a.decrypt.call(this,b,c,d.key,l)}})}();
(function(){for(var u=CryptoJS,p=u.lib.BlockCipher,d=u.algo,l=[],s=[],t=[],r=[],w=[],v=[],b=[],x=[],q=[],n=[],a=[],c=0;256>c;c++)a[c]=128>c?c<<1:c<<1^283;for(var e=0,j=0,c=0;256>c;c++){var k=j^j<<1^j<<2^j<<3^j<<4,k=k>>>8^k&255^99;l[e]=k;s[k]=e;var z=a[e],F=a[z],G=a[F],y=257*a[k]^16843008*k;t[e]=y<<24|y>>>8;r[e]=y<<16|y>>>16;w[e]=y<<8|y>>>24;v[e]=y;y=16843009*G^65537*F^257*z^16843008*e;b[k]=y<<24|y>>>8;x[k]=y<<16|y>>>16;q[k]=y<<8|y>>>24;n[k]=y;e?(e=z^a[a[a[G^z]]],j^=a[a[j]]):e=j=1}var H=[0,1,2,4,8,
16,32,64,128,27,54],d=d.AES=p.extend({_doReset:function(){for(var a=this._key,c=a.words,d=a.sigBytes/4,a=4*((this._nRounds=d+6)+1),e=this._keySchedule=[],j=0;j<a;j++)if(j<d)e[j]=c[j];else{var k=e[j-1];j%d?6<d&&4==j%d&&(k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255]):(k=k<<8|k>>>24,k=l[k>>>24]<<24|l[k>>>16&255]<<16|l[k>>>8&255]<<8|l[k&255],k^=H[j/d|0]<<24);e[j]=e[j-d]^k}c=this._invKeySchedule=[];for(d=0;d<a;d++)j=a-d,k=d%4?e[j]:e[j-4],c[d]=4>d||4>=j?k:b[l[k>>>24]]^x[l[k>>>16&255]]^q[l[k>>>
8&255]]^n[l[k&255]]},encryptBlock:function(a,b){this._doCryptBlock(a,b,this._keySchedule,t,r,w,v,l)},decryptBlock:function(a,c){var d=a[c+1];a[c+1]=a[c+3];a[c+3]=d;this._doCryptBlock(a,c,this._invKeySchedule,b,x,q,n,s);d=a[c+1];a[c+1]=a[c+3];a[c+3]=d},_doCryptBlock:function(a,b,c,d,e,j,l,f){for(var m=this._nRounds,g=a[b]^c[0],h=a[b+1]^c[1],k=a[b+2]^c[2],n=a[b+3]^c[3],p=4,r=1;r<m;r++)var q=d[g>>>24]^e[h>>>16&255]^j[k>>>8&255]^l[n&255]^c[p++],s=d[h>>>24]^e[k>>>16&255]^j[n>>>8&255]^l[g&255]^c[p++],t=
d[k>>>24]^e[n>>>16&255]^j[g>>>8&255]^l[h&255]^c[p++],n=d[n>>>24]^e[g>>>16&255]^j[h>>>8&255]^l[k&255]^c[p++],g=q,h=s,k=t;q=(f[g>>>24]<<24|f[h>>>16&255]<<16|f[k>>>8&255]<<8|f[n&255])^c[p++];s=(f[h>>>24]<<24|f[k>>>16&255]<<16|f[n>>>8&255]<<8|f[g&255])^c[p++];t=(f[k>>>24]<<24|f[n>>>16&255]<<16|f[g>>>8&255]<<8|f[h&255])^c[p++];n=(f[n>>>24]<<24|f[g>>>16&255]<<16|f[h>>>8&255]<<8|f[k&255])^c[p++];a[b]=q;a[b+1]=s;a[b+2]=t;a[b+3]=n},keySize:8});u.AES=p._createHelper(d)})();

/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
/**
 * Zero padding strategy.
 */
CryptoJS.pad.ZeroPadding = {
    pad: function (data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4;

        // Pad
        data.clamp();
        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
    },

    unpad: function (data) {
        // Shortcut
        var dataWords = data.words;

        // Unpad
        if(data.sigBytes > 0) {
            var i = data.sigBytes - 1;
            while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
                i--;
            }
            data.sigBytes = i + 1;
        }
    }
};

/*
 * JavaScript MD5 1.0.1
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*jslint bitwise: true */
/*global unescape, define */

(function ($) {
    'use strict';

    /*
    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
    * to work around bugs in some JS interpreters.
    */
    function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
    }

    /*
    * Bitwise rotate a 32-bit number to the left.
    */
    function bit_rol(num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
    }

    /*
    * These functions implement the four basic operations the algorithm uses.
    */
    function md5_cmn(q, a, b, x, s, t) {
        return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
    }
    function md5_ff(a, b, c, d, x, s, t) {
        return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }
    function md5_gg(a, b, c, d, x, s, t) {
        return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }
    function md5_hh(a, b, c, d, x, s, t) {
        return md5_cmn(b ^ c ^ d, a, b, x, s, t);
    }
    function md5_ii(a, b, c, d, x, s, t) {
        return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    /*
    * Calculate the MD5 of an array of little-endian words, and a bit length.
    */
    function binl_md5(x, len) {
        /* append padding */
        x[len >> 5] |= 0x80 << (len % 32);
        x[(((len + 64) >>> 9) << 4) + 14] = len;

        var i, olda, oldb, oldc, oldd,
            a =  1732584193,
            b = -271733879,
            c = -1732584194,
            d =  271733878;

        for (i = 0; i < x.length; i += 16) {
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;

            a = md5_ff(a, b, c, d, x[i],       7, -680876936);
            d = md5_ff(d, a, b, c, x[i +  1], 12, -389564586);
            c = md5_ff(c, d, a, b, x[i +  2], 17,  606105819);
            b = md5_ff(b, c, d, a, x[i +  3], 22, -1044525330);
            a = md5_ff(a, b, c, d, x[i +  4],  7, -176418897);
            d = md5_ff(d, a, b, c, x[i +  5], 12,  1200080426);
            c = md5_ff(c, d, a, b, x[i +  6], 17, -1473231341);
            b = md5_ff(b, c, d, a, x[i +  7], 22, -45705983);
            a = md5_ff(a, b, c, d, x[i +  8],  7,  1770035416);
            d = md5_ff(d, a, b, c, x[i +  9], 12, -1958414417);
            c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5_ff(a, b, c, d, x[i + 12],  7,  1804603682);
            d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5_ff(b, c, d, a, x[i + 15], 22,  1236535329);

            a = md5_gg(a, b, c, d, x[i +  1],  5, -165796510);
            d = md5_gg(d, a, b, c, x[i +  6],  9, -1069501632);
            c = md5_gg(c, d, a, b, x[i + 11], 14,  643717713);
            b = md5_gg(b, c, d, a, x[i],      20, -373897302);
            a = md5_gg(a, b, c, d, x[i +  5],  5, -701558691);
            d = md5_gg(d, a, b, c, x[i + 10],  9,  38016083);
            c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5_gg(b, c, d, a, x[i +  4], 20, -405537848);
            a = md5_gg(a, b, c, d, x[i +  9],  5,  568446438);
            d = md5_gg(d, a, b, c, x[i + 14],  9, -1019803690);
            c = md5_gg(c, d, a, b, x[i +  3], 14, -187363961);
            b = md5_gg(b, c, d, a, x[i +  8], 20,  1163531501);
            a = md5_gg(a, b, c, d, x[i + 13],  5, -1444681467);
            d = md5_gg(d, a, b, c, x[i +  2],  9, -51403784);
            c = md5_gg(c, d, a, b, x[i +  7], 14,  1735328473);
            b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

            a = md5_hh(a, b, c, d, x[i +  5],  4, -378558);
            d = md5_hh(d, a, b, c, x[i +  8], 11, -2022574463);
            c = md5_hh(c, d, a, b, x[i + 11], 16,  1839030562);
            b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5_hh(a, b, c, d, x[i +  1],  4, -1530992060);
            d = md5_hh(d, a, b, c, x[i +  4], 11,  1272893353);
            c = md5_hh(c, d, a, b, x[i +  7], 16, -155497632);
            b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5_hh(a, b, c, d, x[i + 13],  4,  681279174);
            d = md5_hh(d, a, b, c, x[i],      11, -358537222);
            c = md5_hh(c, d, a, b, x[i +  3], 16, -722521979);
            b = md5_hh(b, c, d, a, x[i +  6], 23,  76029189);
            a = md5_hh(a, b, c, d, x[i +  9],  4, -640364487);
            d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5_hh(c, d, a, b, x[i + 15], 16,  530742520);
            b = md5_hh(b, c, d, a, x[i +  2], 23, -995338651);

            a = md5_ii(a, b, c, d, x[i],       6, -198630844);
            d = md5_ii(d, a, b, c, x[i +  7], 10,  1126891415);
            c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5_ii(b, c, d, a, x[i +  5], 21, -57434055);
            a = md5_ii(a, b, c, d, x[i + 12],  6,  1700485571);
            d = md5_ii(d, a, b, c, x[i +  3], 10, -1894986606);
            c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5_ii(b, c, d, a, x[i +  1], 21, -2054922799);
            a = md5_ii(a, b, c, d, x[i +  8],  6,  1873313359);
            d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5_ii(c, d, a, b, x[i +  6], 15, -1560198380);
            b = md5_ii(b, c, d, a, x[i + 13], 21,  1309151649);
            a = md5_ii(a, b, c, d, x[i +  4],  6, -145523070);
            d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5_ii(c, d, a, b, x[i +  2], 15,  718787259);
            b = md5_ii(b, c, d, a, x[i +  9], 21, -343485551);

            a = safe_add(a, olda);
            b = safe_add(b, oldb);
            c = safe_add(c, oldc);
            d = safe_add(d, oldd);
        }
        return [a, b, c, d];
    }

    /*
    * Convert an array of little-endian words to a string
    */
    function binl2rstr(input) {
        var i,
            output = '';
        for (i = 0; i < input.length * 32; i += 8) {
            output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
        }
        return output;
    }

    /*
    * Convert a raw string to an array of little-endian words
    * Characters >255 have their high-byte silently ignored.
    */
    function rstr2binl(input) {
        var i,
            output = [];
        output[(input.length >> 2) - 1] = undefined;
        for (i = 0; i < output.length; i += 1) {
            output[i] = 0;
        }
        for (i = 0; i < input.length * 8; i += 8) {
            output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
        }
        return output;
    }

    /*
    * Calculate the MD5 of a raw string
    */
    function rstr_md5(s) {
        return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
    }

    /*
    * Calculate the HMAC-MD5, of a key and some data (raw strings)
    */
    function rstr_hmac_md5(key, data) {
        var i,
            bkey = rstr2binl(key),
            ipad = [],
            opad = [],
            hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) {
            bkey = binl_md5(bkey, key.length * 8);
        }
        for (i = 0; i < 16; i += 1) {
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5C5C5C5C;
        }
        hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
    }

    /*
    * Convert a raw string to a hex string
    */
    function rstr2hex(input) {
        var hex_tab = '0123456789abcdef',
            output = '',
            x,
            i;
        for (i = 0; i < input.length; i += 1) {
            x = input.charCodeAt(i);
            output += hex_tab.charAt((x >>> 4) & 0x0F) +
                hex_tab.charAt(x & 0x0F);
        }
        return output;
    }

    /*
    * Encode a string as utf-8
    */
    function str2rstr_utf8(input) {
        return unescape(encodeURIComponent(input));
    }

    /*
    * Take string arguments and return either raw or hex encoded strings
    */
    function raw_md5(s) {
        return rstr_md5(str2rstr_utf8(s));
    }
    function hex_md5(s) {
        return rstr2hex(raw_md5(s));
    }
    function raw_hmac_md5(k, d) {
        return rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d));
    }
    function hex_hmac_md5(k, d) {
        return rstr2hex(raw_hmac_md5(k, d));
    }

    function md5(string, key, raw) {
        if (!key) {
            if (!raw) {
                return hex_md5(string);
            }
            return raw_md5(string);
        }
        if (!raw) {
            return hex_hmac_md5(key, string);
        }
        return raw_hmac_md5(key, string);
    }

    $.md5 = md5;
}(this));

"use strict";var sjcl={cipher:{},hash:{},mode:{},misc:{},codec:{},exception:{corrupt:function(a){this.toString=function(){return"CORRUPT: "+this.message};this.message=a},invalid:function(a){this.toString=function(){return"INVALID: "+this.message};this.message=a},bug:function(a){this.toString=function(){return"BUG: "+this.message};this.message=a},notReady:function(a){this.toString=function(){return"NOT READY: "+this.message};this.message=a}}};
sjcl.cipher.aes=function(a){this.h[0][0][0]||this.z();var b,c,d,e,f=this.h[0][4],g=this.h[1];b=a.length;var h=1;if(b!==4&&b!==6&&b!==8)throw new sjcl.exception.invalid("invalid aes key size");this.a=[d=a.slice(0),e=[]];for(a=b;a<4*b+28;a++){c=d[a-1];if(a%b===0||b===8&&a%b===4){c=f[c>>>24]<<24^f[c>>16&255]<<16^f[c>>8&255]<<8^f[c&255];if(a%b===0){c=c<<8^c>>>24^h<<24;h=h<<1^(h>>7)*283}}d[a]=d[a-b]^c}for(b=0;a;b++,a--){c=d[b&3?a:a-4];e[b]=a<=4||b<4?c:g[0][f[c>>>24]]^g[1][f[c>>16&255]]^g[2][f[c>>8&255]]^
g[3][f[c&255]]}};
sjcl.cipher.aes.prototype={encrypt:function(a){return this.I(a,0)},decrypt:function(a){return this.I(a,1)},h:[[[],[],[],[],[]],[[],[],[],[],[]]],z:function(){var a=this.h[0],b=this.h[1],c=a[4],d=b[4],e,f,g,h=[],i=[],k,j,l,m;for(e=0;e<0x100;e++)i[(h[e]=e<<1^(e>>7)*283)^e]=e;for(f=g=0;!c[f];f^=k||1,g=i[g]||1){l=g^g<<1^g<<2^g<<3^g<<4;l=l>>8^l&255^99;c[f]=l;d[l]=f;j=h[e=h[k=h[f]]];m=j*0x1010101^e*0x10001^k*0x101^f*0x1010100;j=h[l]*0x101^l*0x1010100;for(e=0;e<4;e++){a[e][f]=j=j<<24^j>>>8;b[e][l]=m=m<<24^m>>>8}}for(e=
0;e<5;e++){a[e]=a[e].slice(0);b[e]=b[e].slice(0)}},I:function(a,b){if(a.length!==4)throw new sjcl.exception.invalid("invalid aes block size");var c=this.a[b],d=a[0]^c[0],e=a[b?3:1]^c[1],f=a[2]^c[2];a=a[b?1:3]^c[3];var g,h,i,k=c.length/4-2,j,l=4,m=[0,0,0,0];g=this.h[b];var n=g[0],o=g[1],p=g[2],q=g[3],r=g[4];for(j=0;j<k;j++){g=n[d>>>24]^o[e>>16&255]^p[f>>8&255]^q[a&255]^c[l];h=n[e>>>24]^o[f>>16&255]^p[a>>8&255]^q[d&255]^c[l+1];i=n[f>>>24]^o[a>>16&255]^p[d>>8&255]^q[e&255]^c[l+2];a=n[a>>>24]^o[d>>16&
255]^p[e>>8&255]^q[f&255]^c[l+3];l+=4;d=g;e=h;f=i}for(j=0;j<4;j++){m[b?3&-j:j]=r[d>>>24]<<24^r[e>>16&255]<<16^r[f>>8&255]<<8^r[a&255]^c[l++];g=d;d=e;e=f;f=a;a=g}return m}};
sjcl.bitArray={bitSlice:function(a,b,c){a=sjcl.bitArray.P(a.slice(b/32),32-(b&31)).slice(1);return c===undefined?a:sjcl.bitArray.clamp(a,c-b)},concat:function(a,b){if(a.length===0||b.length===0)return a.concat(b);var c=a[a.length-1],d=sjcl.bitArray.getPartial(c);return d===32?a.concat(b):sjcl.bitArray.P(b,d,c|0,a.slice(0,a.length-1))},bitLength:function(a){var b=a.length;if(b===0)return 0;return(b-1)*32+sjcl.bitArray.getPartial(a[b-1])},clamp:function(a,b){if(a.length*32<b)return a;a=a.slice(0,Math.ceil(b/
32));var c=a.length;b&=31;if(c>0&&b)a[c-1]=sjcl.bitArray.partial(b,a[c-1]&2147483648>>b-1,1);return a},partial:function(a,b,c){if(a===32)return b;return(c?b|0:b<<32-a)+a*0x10000000000},getPartial:function(a){return Math.round(a/0x10000000000)||32},equal:function(a,b){if(sjcl.bitArray.bitLength(a)!==sjcl.bitArray.bitLength(b))return false;var c=0,d;for(d=0;d<a.length;d++)c|=a[d]^b[d];return c===0},P:function(a,b,c,d){var e;e=0;if(d===undefined)d=[];for(;b>=32;b-=32){d.push(c);c=0}if(b===0)return d.concat(a);
for(e=0;e<a.length;e++){d.push(c|a[e]>>>b);c=a[e]<<32-b}e=a.length?a[a.length-1]:0;a=sjcl.bitArray.getPartial(e);d.push(sjcl.bitArray.partial(b+a&31,b+a>32?c:d.pop(),1));return d},k:function(a,b){return[a[0]^b[0],a[1]^b[1],a[2]^b[2],a[3]^b[3]]}};
sjcl.codec.utf8String={fromBits:function(a){var b="",c=sjcl.bitArray.bitLength(a),d,e;for(d=0;d<c/8;d++){if((d&3)===0)e=a[d/4];b+=String.fromCharCode(e>>>24);e<<=8}return decodeURIComponent(escape(b))},toBits:function(a){a=unescape(encodeURIComponent(a));var b=[],c,d=0;for(c=0;c<a.length;c++){d=d<<8|a.charCodeAt(c);if((c&3)===3){b.push(d);d=0}}c&3&&b.push(sjcl.bitArray.partial(8*(c&3),d));return b}};
sjcl.codec.hex={fromBits:function(a){var b="",c;for(c=0;c<a.length;c++)b+=((a[c]|0)+0xf00000000000).toString(16).substr(4);return b.substr(0,sjcl.bitArray.bitLength(a)/4)},toBits:function(a){var b,c=[],d;a=a.replace(/\s|0x/g,"");d=a.length;a+="00000000";for(b=0;b<a.length;b+=8)c.push(parseInt(a.substr(b,8),16)^0);return sjcl.bitArray.clamp(c,d*4)}};
sjcl.codec.base64={F:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(a,b){var c="",d,e=0,f=sjcl.codec.base64.F,g=0,h=sjcl.bitArray.bitLength(a);for(d=0;c.length*6<h;){c+=f.charAt((g^a[d]>>>e)>>>26);if(e<6){g=a[d]<<6-e;e+=26;d++}else{g<<=6;e-=6}}for(;c.length&3&&!b;)c+="=";return c},toBits:function(a){a=a.replace(/\s|=/g,"");var b=[],c,d=0,e=sjcl.codec.base64.F,f=0,g;for(c=0;c<a.length;c++){g=e.indexOf(a.charAt(c));if(g<0)throw new sjcl.exception.invalid("this isn't base64!");
if(d>26){d-=26;b.push(f^g>>>d);f=g<<32-d}else{d+=6;f^=g<<32-d}}d&56&&b.push(sjcl.bitArray.partial(d&56,f,1));return b}};sjcl.hash.sha256=function(a){this.a[0]||this.z();if(a){this.n=a.n.slice(0);this.i=a.i.slice(0);this.e=a.e}else this.reset()};sjcl.hash.sha256.hash=function(a){return(new sjcl.hash.sha256).update(a).finalize()};
sjcl.hash.sha256.prototype={blockSize:512,reset:function(){this.n=this.N.slice(0);this.i=[];this.e=0;return this},update:function(a){if(typeof a==="string")a=sjcl.codec.utf8String.toBits(a);var b,c=this.i=sjcl.bitArray.concat(this.i,a);b=this.e;a=this.e=b+sjcl.bitArray.bitLength(a);for(b=512+b&-512;b<=a;b+=512)this.D(c.splice(0,16));return this},finalize:function(){var a,b=this.i,c=this.n;b=sjcl.bitArray.concat(b,[sjcl.bitArray.partial(1,1)]);for(a=b.length+2;a&15;a++)b.push(0);b.push(Math.floor(this.e/
4294967296));for(b.push(this.e|0);b.length;)this.D(b.splice(0,16));this.reset();return c},N:[],a:[],z:function(){function a(e){return(e-Math.floor(e))*0x100000000|0}var b=0,c=2,d;a:for(;b<64;c++){for(d=2;d*d<=c;d++)if(c%d===0)continue a;if(b<8)this.N[b]=a(Math.pow(c,0.5));this.a[b]=a(Math.pow(c,1/3));b++}},D:function(a){var b,c,d=a.slice(0),e=this.n,f=this.a,g=e[0],h=e[1],i=e[2],k=e[3],j=e[4],l=e[5],m=e[6],n=e[7];for(a=0;a<64;a++){if(a<16)b=d[a];else{b=d[a+1&15];c=d[a+14&15];b=d[a&15]=(b>>>7^b>>>18^
b>>>3^b<<25^b<<14)+(c>>>17^c>>>19^c>>>10^c<<15^c<<13)+d[a&15]+d[a+9&15]|0}b=b+n+(j>>>6^j>>>11^j>>>25^j<<26^j<<21^j<<7)+(m^j&(l^m))+f[a];n=m;m=l;l=j;j=k+b|0;k=i;i=h;h=g;g=b+(h&i^k&(h^i))+(h>>>2^h>>>13^h>>>22^h<<30^h<<19^h<<10)|0}e[0]=e[0]+g|0;e[1]=e[1]+h|0;e[2]=e[2]+i|0;e[3]=e[3]+k|0;e[4]=e[4]+j|0;e[5]=e[5]+l|0;e[6]=e[6]+m|0;e[7]=e[7]+n|0}};
sjcl.mode.ccm={name:"ccm",encrypt:function(a,b,c,d,e){var f,g=b.slice(0),h=sjcl.bitArray,i=h.bitLength(c)/8,k=h.bitLength(g)/8;e=e||64;d=d||[];if(i<7)throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for(f=2;f<4&&k>>>8*f;f++);if(f<15-i)f=15-i;c=h.clamp(c,8*(15-f));b=sjcl.mode.ccm.H(a,b,c,d,e,f);g=sjcl.mode.ccm.J(a,g,c,b,e,f);return h.concat(g.data,g.tag)},decrypt:function(a,b,c,d,e){e=e||64;d=d||[];var f=sjcl.bitArray,g=f.bitLength(c)/8,h=f.bitLength(b),i=f.clamp(b,h-e),k=f.bitSlice(b,
h-e);h=(h-e)/8;if(g<7)throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for(b=2;b<4&&h>>>8*b;b++);if(b<15-g)b=15-g;c=f.clamp(c,8*(15-b));i=sjcl.mode.ccm.J(a,i,c,k,e,b);a=sjcl.mode.ccm.H(a,i.data,c,d,e,b);if(!f.equal(i.tag,a))throw new sjcl.exception.corrupt("ccm: tag doesn't match");return i.data},H:function(a,b,c,d,e,f){var g=[],h=sjcl.bitArray,i=h.k;e/=8;if(e%2||e<4||e>16)throw new sjcl.exception.invalid("ccm: invalid tag length");if(d.length>0xffffffff||b.length>0xffffffff)throw new sjcl.exception.bug("ccm: can't deal with 4GiB or more data");
f=[h.partial(8,(d.length?64:0)|e-2<<2|f-1)];f=h.concat(f,c);f[3]|=h.bitLength(b)/8;f=a.encrypt(f);if(d.length){c=h.bitLength(d)/8;if(c<=65279)g=[h.partial(16,c)];else if(c<=0xffffffff)g=h.concat([h.partial(16,65534)],[c]);g=h.concat(g,d);for(d=0;d<g.length;d+=4)f=a.encrypt(i(f,g.slice(d,d+4).concat([0,0,0])))}for(d=0;d<b.length;d+=4)f=a.encrypt(i(f,b.slice(d,d+4).concat([0,0,0])));return h.clamp(f,e*8)},J:function(a,b,c,d,e,f){var g,h=sjcl.bitArray;g=h.k;var i=b.length,k=h.bitLength(b);c=h.concat([h.partial(8,
f-1)],c).concat([0,0,0]).slice(0,4);d=h.bitSlice(g(d,a.encrypt(c)),0,e);if(!i)return{tag:d,data:[]};for(g=0;g<i;g+=4){c[3]++;e=a.encrypt(c);b[g]^=e[0];b[g+1]^=e[1];b[g+2]^=e[2];b[g+3]^=e[3]}return{tag:d,data:h.clamp(b,k)}}};
sjcl.mode.ocb2={name:"ocb2",encrypt:function(a,b,c,d,e,f){if(sjcl.bitArray.bitLength(c)!==128)throw new sjcl.exception.invalid("ocb iv must be 128 bits");var g,h=sjcl.mode.ocb2.B,i=sjcl.bitArray,k=i.k,j=[0,0,0,0];c=h(a.encrypt(c));var l,m=[];d=d||[];e=e||64;for(g=0;g+4<b.length;g+=4){l=b.slice(g,g+4);j=k(j,l);m=m.concat(k(c,a.encrypt(k(c,l))));c=h(c)}l=b.slice(g);b=i.bitLength(l);g=a.encrypt(k(c,[0,0,0,b]));l=i.clamp(k(l.concat([0,0,0]),g),b);j=k(j,k(l.concat([0,0,0]),g));j=a.encrypt(k(j,k(c,h(c))));
if(d.length)j=k(j,f?d:sjcl.mode.ocb2.pmac(a,d));return m.concat(i.concat(l,i.clamp(j,e)))},decrypt:function(a,b,c,d,e,f){if(sjcl.bitArray.bitLength(c)!==128)throw new sjcl.exception.invalid("ocb iv must be 128 bits");e=e||64;var g=sjcl.mode.ocb2.B,h=sjcl.bitArray,i=h.k,k=[0,0,0,0],j=g(a.encrypt(c)),l,m,n=sjcl.bitArray.bitLength(b)-e,o=[];d=d||[];for(c=0;c+4<n/32;c+=4){l=i(j,a.decrypt(i(j,b.slice(c,c+4))));k=i(k,l);o=o.concat(l);j=g(j)}m=n-c*32;l=a.encrypt(i(j,[0,0,0,m]));l=i(l,h.clamp(b.slice(c),
m).concat([0,0,0]));k=i(k,l);k=a.encrypt(i(k,i(j,g(j))));if(d.length)k=i(k,f?d:sjcl.mode.ocb2.pmac(a,d));if(!h.equal(h.clamp(k,e),h.bitSlice(b,n)))throw new sjcl.exception.corrupt("ocb: tag doesn't match");return o.concat(h.clamp(l,m))},pmac:function(a,b){var c,d=sjcl.mode.ocb2.B,e=sjcl.bitArray,f=e.k,g=[0,0,0,0],h=a.encrypt([0,0,0,0]);h=f(h,d(d(h)));for(c=0;c+4<b.length;c+=4){h=d(h);g=f(g,a.encrypt(f(h,b.slice(c,c+4))))}b=b.slice(c);if(e.bitLength(b)<128){h=f(h,d(h));b=e.concat(b,[2147483648|0,0,
0,0])}g=f(g,b);return a.encrypt(f(d(f(h,d(h))),g))},B:function(a){return[a[0]<<1^a[1]>>>31,a[1]<<1^a[2]>>>31,a[2]<<1^a[3]>>>31,a[3]<<1^(a[0]>>>31)*135]}};sjcl.misc.hmac=function(a,b){this.M=b=b||sjcl.hash.sha256;var c=[[],[]],d=b.prototype.blockSize/32;this.l=[new b,new b];if(a.length>d)a=b.hash(a);for(b=0;b<d;b++){c[0][b]=a[b]^909522486;c[1][b]=a[b]^1549556828}this.l[0].update(c[0]);this.l[1].update(c[1])};
sjcl.misc.hmac.prototype.encrypt=sjcl.misc.hmac.prototype.mac=function(a){a=(new this.M(this.l[0])).update(a).finalize();return(new this.M(this.l[1])).update(a).finalize()};
sjcl.misc.pbkdf2=function(a,b,c,d,e){c=c||1E3;if(d<0||c<0)throw sjcl.exception.invalid("invalid params to pbkdf2");if(typeof a==="string")a=sjcl.codec.utf8String.toBits(a);e=e||sjcl.misc.hmac;a=new e(a);var f,g,h,i,k=[],j=sjcl.bitArray;for(i=1;32*k.length<(d||1);i++){e=f=a.encrypt(j.concat(b,[i]));for(g=1;g<c;g++){f=a.encrypt(f);for(h=0;h<f.length;h++)e[h]^=f[h]}k=k.concat(e)}if(d)k=j.clamp(k,d);return k};
sjcl.random={randomWords:function(a,b){var c=[];b=this.isReady(b);var d;if(b===0)throw new sjcl.exception.notReady("generator isn't seeded");else b&2&&this.U(!(b&1));for(b=0;b<a;b+=4){(b+1)%0x10000===0&&this.L();d=this.w();c.push(d[0],d[1],d[2],d[3])}this.L();return c.slice(0,a)},setDefaultParanoia:function(a){this.t=a},addEntropy:function(a,b,c){c=c||"user";var d,e,f=(new Date).valueOf(),g=this.q[c],h=this.isReady(),i=0;d=this.G[c];if(d===undefined)d=this.G[c]=this.R++;if(g===undefined)g=this.q[c]=
0;this.q[c]=(this.q[c]+1)%this.b.length;switch(typeof a){case "number":if(b===undefined)b=1;this.b[g].update([d,this.u++,1,b,f,1,a|0]);break;case "object":c=Object.prototype.toString.call(a);if(c==="[object Uint32Array]"){e=[];for(c=0;c<a.length;c++)e.push(a[c]);a=e}else{if(c!=="[object Array]")i=1;for(c=0;c<a.length&&!i;c++)if(typeof a[c]!="number")i=1}if(!i){if(b===undefined)for(c=b=0;c<a.length;c++)for(e=a[c];e>0;){b++;e>>>=1}this.b[g].update([d,this.u++,2,b,f,a.length].concat(a))}break;case "string":if(b===
undefined)b=a.length;this.b[g].update([d,this.u++,3,b,f,a.length]);this.b[g].update(a);break;default:i=1}if(i)throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");this.j[g]+=b;this.f+=b;if(h===0){this.isReady()!==0&&this.K("seeded",Math.max(this.g,this.f));this.K("progress",this.getProgress())}},isReady:function(a){a=this.C[a!==undefined?a:this.t];return this.g&&this.g>=a?this.j[0]>80&&(new Date).valueOf()>this.O?3:1:this.f>=a?2:0},getProgress:function(a){a=
this.C[a?a:this.t];return this.g>=a?1:this.f>a?1:this.f/a},startCollectors:function(){if(!this.m){if(window.addEventListener){window.addEventListener("load",this.o,false);window.addEventListener("mousemove",this.p,false)}else if(document.attachEvent){document.attachEvent("onload",this.o);document.attachEvent("onmousemove",this.p)}else throw new sjcl.exception.bug("can't attach event");this.m=true}},stopCollectors:function(){if(this.m){if(window.removeEventListener){window.removeEventListener("load",
this.o,false);window.removeEventListener("mousemove",this.p,false)}else if(window.detachEvent){window.detachEvent("onload",this.o);window.detachEvent("onmousemove",this.p)}this.m=false}},addEventListener:function(a,b){this.r[a][this.Q++]=b},removeEventListener:function(a,b){var c;a=this.r[a];var d=[];for(c in a)a.hasOwnProperty(c)&&a[c]===b&&d.push(c);for(b=0;b<d.length;b++){c=d[b];delete a[c]}},b:[new sjcl.hash.sha256],j:[0],A:0,q:{},u:0,G:{},R:0,g:0,f:0,O:0,a:[0,0,0,0,0,0,0,0],d:[0,0,0,0],s:undefined,
t:6,m:false,r:{progress:{},seeded:{}},Q:0,C:[0,48,64,96,128,192,0x100,384,512,768,1024],w:function(){for(var a=0;a<4;a++){this.d[a]=this.d[a]+1|0;if(this.d[a])break}return this.s.encrypt(this.d)},L:function(){this.a=this.w().concat(this.w());this.s=new sjcl.cipher.aes(this.a)},T:function(a){this.a=sjcl.hash.sha256.hash(this.a.concat(a));this.s=new sjcl.cipher.aes(this.a);for(a=0;a<4;a++){this.d[a]=this.d[a]+1|0;if(this.d[a])break}},U:function(a){var b=[],c=0,d;this.O=b[0]=(new Date).valueOf()+3E4;for(d=
0;d<16;d++)b.push(Math.random()*0x100000000|0);for(d=0;d<this.b.length;d++){b=b.concat(this.b[d].finalize());c+=this.j[d];this.j[d]=0;if(!a&&this.A&1<<d)break}if(this.A>=1<<this.b.length){this.b.push(new sjcl.hash.sha256);this.j.push(0)}this.f-=c;if(c>this.g)this.g=c;this.A++;this.T(b)},p:function(a){sjcl.random.addEntropy([a.x||a.clientX||a.offsetX||0,a.y||a.clientY||a.offsetY||0],2,"mouse")},o:function(){sjcl.random.addEntropy((new Date).valueOf(),2,"loadtime")},K:function(a,b){var c;a=sjcl.random.r[a];
var d=[];for(c in a)a.hasOwnProperty(c)&&d.push(a[c]);for(c=0;c<d.length;c++)d[c](b)}};try{var s=new Uint32Array(32);crypto.getRandomValues(s);sjcl.random.addEntropy(s,1024,"crypto['getRandomValues']")}catch(t){}
sjcl.json={defaults:{v:1,iter:1E3,ks:128,ts:64,mode:"ccm",adata:"",cipher:"aes"},encrypt:function(a,b,c,d){c=c||{};d=d||{};var e=sjcl.json,f=e.c({iv:sjcl.random.randomWords(4,0)},e.defaults),g;e.c(f,c);c=f.adata;if(typeof f.salt==="string")f.salt=sjcl.codec.base64.toBits(f.salt);if(typeof f.iv==="string")f.iv=sjcl.codec.base64.toBits(f.iv);if(!sjcl.mode[f.mode]||!sjcl.cipher[f.cipher]||typeof a==="string"&&f.iter<=100||f.ts!==64&&f.ts!==96&&f.ts!==128||f.ks!==128&&f.ks!==192&&f.ks!==0x100||f.iv.length<
2||f.iv.length>4)throw new sjcl.exception.invalid("json encrypt: invalid parameters");if(typeof a==="string"){g=sjcl.misc.cachedPbkdf2(a,f);a=g.key.slice(0,f.ks/32);f.salt=g.salt}if(typeof b==="string")b=sjcl.codec.utf8String.toBits(b);if(typeof c==="string")c=sjcl.codec.utf8String.toBits(c);g=new sjcl.cipher[f.cipher](a);e.c(d,f);d.key=a;f.ct=sjcl.mode[f.mode].encrypt(g,b,f.iv,c,f.ts);return e.encode(f)},decrypt:function(a,b,c,d){c=c||{};d=d||{};var e=sjcl.json;b=e.c(e.c(e.c({},e.defaults),e.decode(b)),
c,true);var f;c=b.adata;if(typeof b.salt==="string")b.salt=sjcl.codec.base64.toBits(b.salt);if(typeof b.iv==="string")b.iv=sjcl.codec.base64.toBits(b.iv);if(!sjcl.mode[b.mode]||!sjcl.cipher[b.cipher]||typeof a==="string"&&b.iter<=100||b.ts!==64&&b.ts!==96&&b.ts!==128||b.ks!==128&&b.ks!==192&&b.ks!==0x100||!b.iv||b.iv.length<2||b.iv.length>4)throw new sjcl.exception.invalid("json decrypt: invalid parameters");if(typeof a==="string"){f=sjcl.misc.cachedPbkdf2(a,b);a=f.key.slice(0,b.ks/32);b.salt=f.salt}if(typeof c===
"string")c=sjcl.codec.utf8String.toBits(c);f=new sjcl.cipher[b.cipher](a);c=sjcl.mode[b.mode].decrypt(f,b.ct,b.iv,c,b.ts);e.c(d,b);d.key=a;return sjcl.codec.utf8String.fromBits(c)},encode:function(a){var b,c="{",d="";for(b in a)if(a.hasOwnProperty(b)){if(!b.match(/^[a-z0-9]+$/i))throw new sjcl.exception.invalid("json encode: invalid property name");c+=d+'"'+b+'":';d=",";switch(typeof a[b]){case "number":case "boolean":c+=a[b];break;case "string":c+='"'+escape(a[b])+'"';break;case "object":c+='"'+
sjcl.codec.base64.fromBits(a[b],1)+'"';break;default:throw new sjcl.exception.bug("json encode: unsupported type");}}return c+"}"},decode:function(a){a=a.replace(/\s/g,"");if(!a.match(/^\{.*\}$/))throw new sjcl.exception.invalid("json decode: this isn't json!");a=a.replace(/^\{|\}$/g,"").split(/,/);var b={},c,d;for(c=0;c<a.length;c++){if(!(d=a[c].match(/^(?:(["']?)([a-z][a-z0-9]*)\1):(?:(\d+)|"([a-z0-9+\/%*_.@=\-]*)")$/i)))throw new sjcl.exception.invalid("json decode: this isn't json!");b[d[2]]=
d[3]?parseInt(d[3],10):d[2].match(/^(ct|salt|iv)$/)?sjcl.codec.base64.toBits(d[4]):unescape(d[4])}return b},c:function(a,b,c){if(a===undefined)a={};if(b===undefined)return a;var d;for(d in b)if(b.hasOwnProperty(d)){if(c&&a[d]!==undefined&&a[d]!==b[d])throw new sjcl.exception.invalid("required parameter overridden");a[d]=b[d]}return a},V:function(a,b){var c={},d;for(d=0;d<b.length;d++)if(a[b[d]]!==undefined)c[b[d]]=a[b[d]];return c}};sjcl.encrypt=sjcl.json.encrypt;sjcl.decrypt=sjcl.json.decrypt;
sjcl.misc.S={};sjcl.misc.cachedPbkdf2=function(a,b){var c=sjcl.misc.S,d;b=b||{};d=b.iter||1E3;c=c[a]=c[a]||{};d=c[d]=c[d]||{firstSalt:b.salt&&b.salt.length?b.salt.slice(0):sjcl.random.randomWords(2,0)};c=b.salt===undefined?d.firstSalt:b.salt;d[c]=d[c]||sjcl.misc.pbkdf2(a,c,b.iter);return{key:d[c].slice(0),salt:c.slice(0)}};

/**
 * DPLocksmith
 *
 * @module      :: DPLocksmith
 * @description :: DirectPass encrypted and decrypted.
 * @author         Isken Huang <iskenhuang@gmail.com>
 */

'use strict';

(function(window, CryptoJS, sjcl) {
    /**
     * @constructor
     */
    var DPKeyProcessor = function() {},
        JSON = window.JSON,
        console = window.console,
        /**
         * Logger
         */
        logger = function() {
            var defaultLog = {
                    info: function() {},
                    debug: function() {},
                    log: function() {},
                    warn: function(){},
                    error: function() {}
                };

            console = console ? console : defaultLog;
            var args = Array.prototype.slice.call(arguments);
            void 0;
        };

    DPKeyProcessor.prototype =  {
        /**
         * Config
         *
         * @type {Object}
         */
        config: {
            apiMasterPasswordUrl: '/api/masterpassword',
            apiErrorRedirect: '/error',

            signatureAndIdentifierString: 'SPARDA',

            encryptedKeyString: 'pdata1',
            encryptedVecString: 'pdata2',
            encryptedMasterPin: 'masterPin',
            encryptedGoldenKey: 'gk',

            iterations: 2000,
            iterationsFast: 100,
            cookieName: 'data'
        },

        /**
         * CryptoJS module cache
         *
         * @type {Function}
         */
        CryptoJS: CryptoJS,

        /**
         * MD5 module cache
         *
         * @type {Function}
         */
        MD5: window.md5,

        sjcl: sjcl,
        /**
         * getErrorCode
         *
         * If does not input any error code will return all error map.
         *
         * @param  {String} code error code
         * @return {Object}
         */
        getErrorCode: function(code){
            logger('getErrorCode begin code = ', code);
            var errorMap = {
                    // Can not access localStorage (i.e. Safari private mode)
                    '94000010': {
                        action: 'redirect',
                        url: this.config.apiErrorRedirect + '/94000010'
                    },
                    'default': {
                        action: 'redirect',
                        url: this.config.apiErrorRedirect
                    }
                },
                _error = errorMap[code] || errorMap['default'];

            if(!_error) {
                return errorMap;
            }

            return _error;
        },

        /**
         * errorhandle
         *
         * @param  {String} code error code or default
         * @return {Self}
         */
        errorhandle: function(code){
            logger('errorhandle begin code = ', code);
            var _error = this.getErrorCode(code);

            switch(_error.action.toLowerCase()) {

            case 'redirect':
                window.location.href = _error.url;
                break;

            default:
                window.location.href = _error.url;
                break;
            }

            return this;
        },

        /**
         * getCookie
         *
         * @param  {String} cname cookie key
         * @return {string}       empty string or cookie string
         */
        getCookie: function(cname) {
            logger('getCookie begin cname = ', cname);
            var name = cname + '=',
                ca = document.cookie.split(';'),
                c = '';
            for ( var i = 0; i < ca.length; i++ ) {
                c = ca[i].replace(/^\s+|\s+$/g, '');
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length,c.length);
                }
            }
            return '';
        },

        /**
         * setCookie
         * @param {String} cname  Cookie key
         * @param {String} cvalue Cookie value
         *
         * @return {self}
         */
        setCookie: function(cname,cvalue) {
            logger('setCookie begin cname = ', cname);
            logger('setCookie begin cvalue = ', cvalue);
            document.cookie = cname + '=' + window.escape(cvalue) + '; ';
            return this;
        },

        /**
         * getLocalStorage
         *
         * @param  {String} key     localStorage key
         * @return {String|Object}
         */
        getLocalStorage: function(key) {
            logger('getLocalStorage begin key = ', key);
            return this.isLocalStorageUsable() ? window.localStorage.getItem(key) : null;
        },

        /**
         * setLocalStorage
         *
         * @param {String}          key
         * @param {String|Object}   value
         *
         * @return {self}
         */
        setLocalStorage: function(key, value) {
            logger('setLocalStorage begin key = ', key);
            logger('setLocalStorage begin value = ', value);
            if(this.isLocalStorageUsable()) {
                value = (typeof(value) === 'object') ? JSON.stringify(value) : value;
                window.localStorage.setItem( key, value);
            }

            return this;
        },

        /**
         * deleteLocalStorage
         *
         * @param {String}          key
         * @param {String|Object}   value
         */
        deleteLocalStorage: function(key) {
            logger('deleteLocalStorage begin key = ', key);
            if(this.isLocalStorageUsable()) {
                window.localStorage.removeItem(key);
                // delete window.localStorage[key];
            }

            return this;
        },

        /**
         * isLocalStorageUsable
         *
         * @return {Boolean} LocalStorage is usable
         */
        isLocalStorageUsable: function() {
            logger('isLocalStorageUsable begin');
            var k = 'test',
                v = '1',
                storage = window.sessionStorage;

            try {
                storage.setItem(k, v);
                storage.removeItem(k);

                this.isLocalStorage = true;

            } catch(error) {

                this.isLocalStorage = false;
                this.errorhandle('94000010');

                // Safari private mode check
                // if(error.code === window.DOMException.QUOTA_EXCEEDED_ERR && storage.length === 0) {
                //     return true;
                // }else{
                //     throw error;
                // }
            }

            return this.isLocalStorage;
        },

        /**
         * cleanLocalStorage
         *
         * delete saved goldenKey and masterPin
         *
         * @return {self}
         */
        cleanLocalStorage: function() {
            logger('cleanLocalStorage begin');
            for(var i in this.config) {
                if(i.match(/^encrypted/i)) {
                    this.deleteLocalStorage(this.config[i]);
                }
            }

            return this;
        },

        /**
         * getCookieKey
         *
         * If get cookie success will return key. If cookie not found will return null.
         *
         * @return {Null|Object} AESPack
         */
        getCookieKey: function() {
            logger('getCookiesAES begin');
            var cookie = this.getCookie(this.config.cookieName);
            if (!cookie) {
                return null;
            }

            var initiator = this.getPbkdf2StringFast(cookie);
            while(initiator.length<100){
                initiator+=initiator;
            }

            var cookieAES = this.getAESPackageFast(cookie, initiator.substr(0,100)),
                cookieKey = {
                    Major: cookieAES.Key,
                    Auxiliary: cookieAES.Vec
                };

            return cookieKey;
        },

        /**
         * saveEncryptedGoldenKey
         *
         *
         * @param  {Object} goldenKey goldenKey
         * @return {Boolen}           succes or not
         */
        saveEncryptedGoldenKey: function(goldenKey) {
            logger('saveEncryptedGoldenKey begin');

            var cookieKey = this.getCookieKey();
            if(!cookieKey) {
                return false;
            }

            var encryptedGoldenKey = this.encryptString( cookieKey, goldenKey);

            try {
                this.setLocalStorage( this.config.encryptedGoldenKey, encryptedGoldenKey);
                return true;
            } catch(e) {
                return false;
            }
        },

        /**
         * getDecryptedGoldenKey
         * @return {Object} GoldenKey
         */
        getDecryptedGoldenKey: function() {
            logger('getDecryptedGoldenKey begin');

            var cookieKey = this.getCookieKey();
            if(!cookieKey) {
                return false;
            }

            var encryptedGoldenKey = this.getLocalStorage( this.config.encryptedGoldenKey);

            if(!encryptedGoldenKey) {
                return null;
            }

            var goldenKey = this.decryptString( cookieKey, encryptedGoldenKey);

            this.goldenKey = JSON.parse(goldenKey);

            return this.goldenKey;
        },

        /**
         * saveEncryptedMasterPassword
         *
         * save encrypted masterpassword to localStorage
         *
         * @param  {String} masterpassword user input masterpassword
         * @return {Boolean}               success or fail
         */
        saveEncryptedMasterPassword: function(masterpassword) {
            logger('saveEncryptedMasterPassword begin masterpassword = ', masterpassword);

            var cookieKey = this.getCookieKey();
            if(!cookieKey) {
                return false;
            }

            var masterPasswordAES,
                encKey,
                encVec;

            if(typeof(masterpassword) === 'string') {
                var cacheMasterPin = this.getLocalStorage(this.config.encryptedMasterPin);
                var masterPin = (typeof(cacheMasterPin) === 'string') ? JSON.parse(cacheMasterPin) : cacheMasterPin;
                masterPasswordAES = this.getAESPackage(masterpassword, masterPin.Initiator);
            }else {
                if(masterpassword.Major && masterpassword.Auxiliary) {
                    // special case!!
                    // for isMatchSecurityQuestionsAnswer
                    // save golden key
                    masterPasswordAES = {
                        Key: JSON.stringify(masterpassword.Major),
                        Vec: JSON.stringify(masterpassword.Auxiliary)
                    };
                }else if(masterpassword.Key && masterpassword.Vec){
                    masterPasswordAES = masterpassword;
                }else{
                    return false;
                }
            }

            encKey = this.encryptString( cookieKey, masterPasswordAES.Key.toString());
            encVec = this.encryptString( cookieKey, masterPasswordAES.Vec.toString());

            try {
                this.setLocalStorage( this.config.encryptedKeyString, encKey);
                this.setLocalStorage( this.config.encryptedVecString, encVec);
            } catch(e) {
                if(e.code === 22) {
                    return false;
                } else {
                    throw e;
                }
            }
            return true;
        },

        /**
         * getDecryptedMasterPassword
         *
         * get masterpassword from localStorage and decrypted
         *
         * @return {Object} MasterPassword AES key or null
         */
        getDecryptedMasterPassword: function() {
            logger('getDecryptedMasterPassword begin');

            var pdata1 = this.getLocalStorage( this.config.encryptedKeyString),
                pdata2 = this.getLocalStorage( this.config.encryptedVecString);

            if(!pdata1 || !pdata2) {
                return null;
            }

            var cookieKey = this.getCookieKey(),
                masterKey = {};

            if(!cookieKey) {
                return null;
            }

            masterKey.Key = CryptoJS.enc.Hex.parse(this.decryptString(cookieKey, pdata1));
            masterKey.Vec = CryptoJS.enc.Hex.parse(this.decryptString(cookieKey, pdata2));

            return masterKey;
        },

        /**
         * getAESPackage
         *
         * @param  {String} Used this string create AES package
         * @return {Object} AES key package
         */
        getAESPackage: function(masterPin, initiator) {
            logger('getAESPackage begin');
            var AESPackage = this.imp_getAESPackage(masterPin, initiator,this.config.iterations);
            return AESPackage;
        },

        /**
         * getAESPackageFast
         * For cookie key
         * @param  {String} Used this string create AES package
         * @return {Object} AES key package
         */
        getAESPackageFast: function(masterPin, initiator) {
            logger('getAESPackageFast begin');
            var AESPackage = this.imp_getAESPackage(masterPin, initiator,this.config.iterationsFast);
            return AESPackage;
        },

        /**
         * imp_getAESPackage
         *
         * @param  {String} Used this string create AES package
         * @return {Object} AES key package
         */
        imp_getAESPackage: function(masterPin, initiator, iterations) {
            logger('getAESPackage begin masterPin = ', masterPin);
            var predefPassword = initiator,
                ucPin = CryptoJS.enc.Utf8.parse(masterPin),
                password = ucPin.toString(CryptoJS.enc.Hex).concat(predefPassword.substr(ucPin.toString(CryptoJS.enc.Hex).length)),
                sSalt = password.substr(0, 12 * 2),
                sPassword = password.substr(12 * 2, 12 * 2),
                AESPackage = {};

            AESPackage.Key = CryptoJS.enc.Hex.parse(sjcl.codec.hex.fromBits(sjcl.misc.pbkdf2(sjcl.codec.hex.toBits(sPassword), sjcl.codec.hex.toBits(sSalt),iterations)));

            sSalt = password.substr(25 * 2, 12 * 2);
            sPassword = password.substr(25 * 2 + 12 * 2, 12 * 2);
            AESPackage.Vec = CryptoJS.enc.Hex.parse(sjcl.codec.hex.fromBits(sjcl.misc.pbkdf2(sjcl.codec.hex.toBits(sPassword), sjcl.codec.hex.toBits(sSalt),iterations)));

            logger('getAESPackage AESPackage = ', AESPackage);
            return AESPackage;
        },

        /**
         * getPredefineKey
         * @return {Object} AES package
         */
        getPredefineKey: function() {
            logger('getPredefineKey begin');
            var AESPackage = {
                Major: CryptoJS.enc.Hex.parse('42a03ca4e74f5e49344ed60132be8c2600000000000000000000000000000000'),
                Auxiliary: CryptoJS.enc.Hex.parse('1a31b0d95da848a38c183ebcfe213e9900000000000000000000000000000000')
            };

            logger('getPredefineKey AESPackage = ', AESPackage);
            return AESPackage;
        },

        /**
         * decryptKey
         *
         * @param  {Object} keyPackage Key
         * @param  {String} masterPin  keyString
         * @return {Object}            Full key package
         */
        decryptKey: function(keyPackage, masterPin) {
            logger('decryptKey begin keyPackage = ', keyPackage);
            logger('decryptKey begin masterPin = ', masterPin);
            var AESPackage = this.getAESPackage(masterPin, keyPackage.Initiator),
                result = {};
            result = this.decryptKeyByAES(keyPackage, AESPackage);

            logger('decryptKey result = ', result);
            return result;
        },

        /**
         * decryptKeyByAES
         *
         * @param  {Object} keyPackage Key
         * @param  {Object} AESPackage AES Key
         * @return {Object}            Full key package
         */
        decryptKeyByAES: function(keyPackage, AESPackage) {
            logger('decryptKeyByAES begin keyPackage = ', keyPackage);
            logger('decryptKeyByAES begin AESPackage = ', AESPackage);
            var decryptedKeyPackage = {};

            decryptedKeyPackage.Major = CryptoJS.AES.decrypt(keyPackage.Major, AESPackage.Key, {
                iv: AESPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            });

            decryptedKeyPackage.Auxiliary = CryptoJS.AES.decrypt(keyPackage.Auxiliary, AESPackage.Key, {
                iv: AESPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            });

            decryptedKeyPackage.Signature = CryptoJS.AES.decrypt(keyPackage.Signature, AESPackage.Key, {
                iv: AESPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            });

            decryptedKeyPackage.Identifier = CryptoJS.AES.decrypt(keyPackage.Identifier, decryptedKeyPackage.Major, {
                iv: decryptedKeyPackage.Auxiliary,
                padding: CryptoJS.pad.ZeroPadding
            });

            if(decryptedKeyPackage.Signature.toString() === decryptedKeyPackage.Identifier.toString() &&
               decryptedKeyPackage.Signature.toString(CryptoJS.enc.Utf8) === this.config.signatureAndIdentifierString) {
                return decryptedKeyPackage;
            }else {
                return null;
            }
        },

        /**
         * createKey
         *
         * @param  {String} masterPin Key string
         * @param  {Object} goldenKey GoldenKey or undefinded. not required
         * @return {Object}           Full key package
         */
        createKey: function(masterPin, goldenKey) {
            logger('createKey begin masterPin = ', masterPin);
            logger('createKey begin goldenKey = ', goldenKey);
            if(!masterPin) {
                return null;
            }

            var initiator = CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(100)),
                ASEPackage = this.getAESPackage(masterPin, initiator),
                Major = (goldenKey) ? goldenKey.Major: CryptoJS.lib.WordArray.random(32),
                Auxiliary = (goldenKey) ? goldenKey.Auxiliary: CryptoJS.lib.WordArray.random(32),
                encryptedKeyPackage = {};

            encryptedKeyPackage.Initiator = initiator;

            encryptedKeyPackage.Major = CryptoJS.AES.encrypt( Major, ASEPackage.Key, {
                iv: ASEPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();

            encryptedKeyPackage.Auxiliary = CryptoJS.AES.encrypt( Auxiliary, ASEPackage.Key, {
                iv: ASEPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();

            encryptedKeyPackage.Signature = CryptoJS.AES.encrypt( this.config.signatureAndIdentifierString, ASEPackage.Key, {
                iv: ASEPackage.Vec,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();

            encryptedKeyPackage.Identifier = CryptoJS.AES.encrypt( this.config.signatureAndIdentifierString, Major, {
                iv: Auxiliary,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();

            return encryptedKeyPackage;
        },

        /**
         * decryptString
         *
         * decrypted string
         *
         * @param  {Object} keyPackage    Key
         * @param  {String} encryptString encrypted string
         * @return {String|null}
         */
        decryptString: function (keyPackage, encryptString) {
            logger('decryptString begin keyPackage = ', keyPackage);
            logger('decryptString begin encryptString = ', encryptString);
            if(typeof(encryptString) === 'object') {
                encryptString = JSON.stringify(encryptString);
            }

            if(!encryptString.length) {
                return null;
            }

            try {
                return CryptoJS.AES.decrypt(encryptString, keyPackage.Major, {
                    iv: keyPackage.Auxiliary,
                    padding: CryptoJS.pad.ZeroPadding
                }).toString(CryptoJS.enc.Utf8);
            }catch(e){
                logger('e = ', e);
                return null;
            }
        },

        /**
         * encryptString
         *
         * @param  {Object} keyPackage Key
         * @param  {String} plainText  Should be encrypted string
         * @return {String|Null}
         */
        encryptString: function (keyPackage, plainText){
            logger('encryptString begin keyPackage = ', keyPackage);
            logger('encryptString begin plainText = ', plainText);
            if(typeof(plainText) === 'object') {
                plainText = JSON.stringify(plainText);
            }

            if(!plainText.length) {
                return null;
            }

            return CryptoJS.AES.encrypt(plainText, keyPackage.Major, {
                iv: keyPackage.Auxiliary,
                padding: CryptoJS.pad.ZeroPadding
            }).toString();
        },

        /**
         * getPbkdf2String
         * @param  {String} plainText
         * @return {Object}
         */
        getPbkdf2String: function (plainText) {
            logger('getPbkdf2String begin plainText = ', plainText);
            return sjcl.codec.hex.fromBits(sjcl.misc.pbkdf2(plainText, sjcl.codec.utf8String.toBits(plainText),this.config.iterations)).toUpperCase();
        },

        /**
         * getPbkdf2StringFast
         * @param  {String} plainText
         * @return {Object}
         */
        getPbkdf2StringFast: function (plainText) {
            logger('getPbkdf2String begin plainText = ', plainText);
            return sjcl.codec.hex.fromBits(sjcl.misc.pbkdf2(plainText, sjcl.codec.utf8String.toBits(plainText),this.config.iterationsFast)).toUpperCase();
        },
        
        /**
         * ajax/ http request
         *
         * @param  {String}   url    http request url
         * @param  {Function} cb     callback(http response)
         * @param  {String}   body   http request body
         * @param  {Object}   header http request header
         */
        ajax: function( url, cb, body, header) {
            logger('ajax begin url = ', url);
            logger('ajax begin cb = ', cb);
            logger('ajax begin body = ', body);
            logger('ajax begin header = ', header);
            var XHR = (window.ActiveXObject) ? window.ActiveXObject : window.XMLHttpRequest;
            header = (typeof(header) === 'object') ? header : {};
            XHR = new XHR('Microsoft.XMLHTTP');
            XHR.open( body ? 'POST' : 'GET', url, 1);
            XHR.setRequestHeader('Content-type','application/x-www-form-urlencoded');
            for(var i in header) {
                XHR.setRequestHeader( i, header[i]);
            }
            XHR.onreadystatechange = function(){
                // XHR.readyState > 3 && cb ? cb( XHR.responseText, XHR) : 0;
                if(XHR.readyState > 3 && cb) {
                    cb( XHR.responseText, XHR);
                }else{
                    cb(null, null);
                }
            };
            XHR.send(body);
        },

        /**
         * getMasterPin
         *
         * get MasterPin from server. Get http response from servce.
         *
         *
         * @param  {Function} callback
         * @return {Function} null or MasterPin
         */
        getMasterPin: function(cb) {
            logger('getMasterPin begin cb = ', cb);
            var _this = this,
                cacheMasterPin = this.getLocalStorage(this.config.encryptedMasterPin);

            if(cacheMasterPin) {
                cacheMasterPin = (typeof(cacheMasterPin) === 'string') ? JSON.parse(cacheMasterPin) : cacheMasterPin;
                return cb(cacheMasterPin);
            }else{
                this.ajax( this.config.apiMasterPasswordUrl, function(res) {
                    var _res = (typeof(res) === 'object') ? res : JSON.parse(res);
                    logger('_res = ', _res);
                    if(_res.returncode === '0') {
                        var _data = _res.data[0] || null;

                        // save masterPin when get masterPin success
                        if(_data) {
                            _this.setLocalStorage( _this.config.encryptedMasterPin, JSON.stringify(_data));
                        }

                        return cb(_data);
                    }else{
                        return cb(null);
                    }
                });
            }
        },

        /**
         * getGoldenKey
         *
         * If cached golden Key will return golden key or return in callback(last params)
         * If not cached golden key please input masterPassword(String). this function
         * will send HttpRequest to server to get masterPin. And decrytped golden key
         * return in callback function and cached in memory.
         *
         * @param  {String|Function}   masterPassword normal is string(masterPassword). function when golden key is cached
         * @param  {Function} cb
         * @return {Object}                  Golden key
         */
        getGoldenKey: function(masterPassword, cb) {
            logger('getGoldenKey begin masterPassword = ', masterPassword);
            logger('getGoldenKey begin cb = ', cb);
            var _this = this,
                goldenKey,
                cacheMasterPin,
                decryptedGoldenKey = function(mPin, mPassword) {
                    mPin = (typeof(mPin) === 'string') ? JSON.parse(mPin): mPin;

                    if(typeof(mPassword) === 'string') {
                        return _this.decryptKey( mPin, mPassword);
                    }else{
                        return _this.decryptKeyByAES( mPin, mPassword);
                    }
                };

            if(_this.goldenKey) {
                if((typeof(masterPassword) === 'function')) {
                    return masterPassword(_this.goldenKey);
                }else if((typeof(cb) === 'function')) {
                    return cb(this.goldenKey);
                }else{
                    return _this.goldenKey;
                }
            }

            // get cached masterPin
            cacheMasterPin = this.getLocalStorage(this.config.encryptedMasterPin);

            // Used cached master password get from localStorage pdata1 and pdata2
            if(typeof(masterPassword) === 'function') {
                var cacheMasterPasswordAES = _this.getDecryptedMasterPassword();

                if(cacheMasterPasswordAES && cacheMasterPin) {
                    goldenKey = decryptedGoldenKey(cacheMasterPin, cacheMasterPasswordAES);
                    _this.goldenKey = goldenKey;

                    return goldenKey;
                }
            }

            if(cacheMasterPin) {
                goldenKey = decryptedGoldenKey(cacheMasterPin, masterPassword);
                _this.goldenKey = goldenKey;

                return cb(goldenKey);
            }else{
                this.getMasterPin(function(res){
                    if(res) {
                        goldenKey = decryptedGoldenKey( res, masterPassword);
                        _this.goldenKey = goldenKey;
                        return cb(goldenKey);
                    }else{
                        return cb(null);
                    }
                });
            }
        },

        /**
         * isMatchMasterPassword
         *
         * check master password is right or wrong.
         *
         * @param  {String}  masterPassword user input password string
         * @return {Boolean}
         */
        isMatchMasterPassword: function(masterPassword) {
            logger('isMatchMasterPassword begin masterPassword = ', masterPassword);

            var masterPin = JSON.parse(this.getLocalStorage(this.config.encryptedMasterPin)),
                _currentMP = this.getDecryptedMasterPassword(),
                _newMP = this.getAESPackage(masterPassword, masterPin.Initiator);

            if(_currentMP.Key.toString() === _newMP.Key.toString() &&
               _currentMP.Vec.toString() === _newMP.Vec.toString()) {
                return true;
            }else{
                return false;
            }
        },

        /**
         * getSessionKeyAES
         *
         * generate AES package from session key
         *
         * @param  {String}  sessionKey key for generate AES directly length >= 64
         * @return {Object}  AESpackage from sessionKey
         */
        getSessionKeyAES: function(sessionKey) {
            if(sessionKey.length < 64) {
                return false;
            }
            var sessionKeyAES ={
                Major: CryptoJS.enc.Hex.parse(sessionKey.substring(0,32)+'00000000000000000000000000000000'),
                Auxiliary: CryptoJS.enc.Hex.parse(sessionKey.substring(32,64)+'00000000000000000000000000000000')
            };
            return sessionKeyAES;
        },

        /**
         * getSessionKeyEncryptedMasterPasswordPackage
         *
         * generate AES package from session key
         *
         * @param  {String}  masterPassword user input master password
         * @param  {Object}  masterPin masterPin table from DB
         * @param  {String}  sessionKey session key from tower service
         * @return {Object|null}  encrypted master password package or null if fail
         */
        getSessionKeyEncryptedMasterPasswordPackage: function(masterPassword, masterPin, sessionKey) {
            var masterPasswordAES = this.getAESPackage(masterPassword, masterPin.Initiator);
            var goldenKey = this.decryptKeyByAES(masterPin, masterPasswordAES);
            if(!goldenKey) {
                return null;
            }

            var sessionKeyAES = this.getSessionKeyAES(sessionKey);
            if(!sessionKeyAES) {
                return null;
            }

            var masterPasswordPackage = {};
            masterPasswordPackage.Key = masterPasswordAES.Key.toString();
            masterPasswordPackage.Vec = masterPasswordAES.Vec.toString();

            var encryptedMasterPasswordPackage = {};
            encryptedMasterPasswordPackage.data = this.encryptString( sessionKeyAES, JSON.stringify(masterPasswordPackage));
            encryptedMasterPasswordPackage.Signature = masterPin.Signature;
            return encryptedMasterPasswordPackage;
        },

        /**
         * getSessionKeyDecryptedMasterPasswordPackage
         *
         * generate AES package from session key
         *
         * @param  {Object}  sessionKeyEncryptedPackage data from getSessionKeyEncryptedMasterPasswordPackage function
         * @param  {Object}  masterPin masterPin table from DB
         * @param  {String}  sessionKey session key from tower service
         * @return {Object|null}  master password package or null if fail
         */
        getSessionKeyDecryptedMasterPasswordPackage: function(sessionKeyEncryptedPackage, masterPin, sessionKey) {
            if(sessionKeyEncryptedPackage.Signature !== masterPin.Signature) {
                return null;
            }
            var sessionKeyAES = this.getSessionKeyAES(sessionKey);
            if(!sessionKeyAES) {
                return null;
            }

            var encryptedMasterPasswordPackage = {};
            try{
                var decryptedData = this.decryptString( sessionKeyAES, sessionKeyEncryptedPackage.data);
                if(!decryptedData)
                    return null;
                encryptedMasterPasswordPackage = JSON.parse(decryptedData);
            }
            catch (error) {
                return null;
            }

            var decryptedMasterPasswordPackage = {};
            decryptedMasterPasswordPackage.Key = CryptoJS.enc.Hex.parse(encryptedMasterPasswordPackage.Key);
            decryptedMasterPasswordPackage.Vec = CryptoJS.enc.Hex.parse(encryptedMasterPasswordPackage.Vec);
            return decryptedMasterPasswordPackage;
        },
        setJSON: function(customJSON) {
            JSON = customJSON;
        },
        setConsole: function(customConsole) {
            console = customConsole;
        }
    };

    //EXPORTS
    //CommonJS
    if (typeof require === 'function' && typeof module !== 'undefined' && exports) {
        module.exports = DPKeyProcessor;
    }

})(this, CryptoJS, sjcl);
